// Components
import { Link } from '@tracklib/kit'

// Types
import type { Region } from 'types'

// Utils
import styles from './infoitem2.css'

type RegionsProps = {
  regions: Array<Region>
  showAll?: boolean
  displayAsRow?: boolean
  isModal: boolean
  modalOpen?: boolean
  toggleModalOpen?: (open: boolean) => null
}

const Regions = ({ regions, showAll, displayAsRow, modalOpen, isModal, toggleModalOpen }: RegionsProps) => {
  if (!regions.length) {
    return null
  }

  const firstRegion = regions[0]
  const regionsLength = regions.length

  if (showAll || isModal) {
    return (
      <>
        {regions
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((x, i) => (
            <span key={String(x.id)}>
              <Link to={`/tracks?regions=${firstRegion.id}`}>{firstRegion.name}</Link>
              {showAll && displayAsRow && regionsLength !== i + 1 && <span>&nbsp;&nbsp;</span>}
            </span>
          ))}
      </>
    )
  }

  return (
    <span>
      <Link to={`/tracks?regions=${firstRegion.id}`}>{firstRegion.name}</Link>
      {regionsLength > 1 && (
        <>
          <span className={styles.plus}>&nbsp;&#43;&nbsp;</span>
          <Link onClick={() => toggleModalOpen && toggleModalOpen(!modalOpen)}>{regionsLength - 1} more</Link>
        </>
      )}
    </span>
  )
}

export default Regions
